import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgApexchartsModule } from 'ng-apexcharts';
import { LightboxModule } from 'ngx-lightbox';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { LightgalleryModule } from 'lightgallery/angular';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { NgxEditorModule } from 'ngx-editor';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { FullCalendarModule } from '@fullcalendar/angular';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DatePicker } from 'primeng/datepicker';
import { GoogleMapsModule } from '@angular/google-maps';
import { CommonCounterComponent } from '../feature-module/core/common/common-counter/common-counter.component';
import { DateRangePickerModule } from '../feature-module/core/common/date-range-picker/date-range-picker.module';
import { FooterComponent } from '../feature-module/core/common/footer/footer.component';
import { UserDashboardComponent } from '../feature-module/core/common/user-dashboard/user-dashboard.component';
import { BookingSearchBarComponent } from '../feature-module/core/common/booking-search-bar/booking-search-bar.component';
import { DefaultHeaderComponent } from '../feature-module/core/common/default-header/default-header.component';
import { RouterModule } from '@angular/router';
import { HeaderTopBarComponent } from '../feature-module/core/common/header-top-bar/header-top-bar.component';
import { LocationPickerComponent } from '../feature-module/core/common/location-picker/location-picker.component';
import { FlightSearchComponent } from '../feature-module/core/common/flight-search/flight-search.component';
import { HotelSearchComponent } from '../feature-module/core/common/hotel-search/hotel-search.component';
import { PaginatorComponent } from '../feature-module/core/common/paginator/paginator.component';
import { CityPickerComponent } from '../feature-module/core/common/city-picker/city-picker.component';
import { CarSearchComponent } from '../feature-module/core/common/car-search/car-search.component';
import { SelectComponent } from './components/select/select.component';
import { StaticContentComponent } from './components/static-content/static-content.component';
import { CustomPaginationModule } from '../shared/custom-pagination/custom-pagination.module';



@NgModule({
  declarations: [
    FooterComponent,
    DefaultHeaderComponent,
    CommonCounterComponent,
    UserDashboardComponent,
    BookingSearchBarComponent,
    HeaderTopBarComponent,
    LocationPickerComponent,
    FlightSearchComponent,
    HotelSearchComponent,
    CityPickerComponent,
    PaginatorComponent,
    CarSearchComponent,
    StaticContentComponent,
    
  ],
  imports: [
    CommonModule,
    NgScrollbarModule,
    MatTooltipModule,
    LightboxModule,
    CarouselModule,
    BsDatepickerModule.forRoot(),
    LightgalleryModule,
    MatSelectModule,
    MatSortModule,
    NgScrollbarModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgApexchartsModule,
    TooltipModule.forRoot(),
    ToastModule,
    NgxEditorModule,
    PopoverModule,
    GoogleMapsModule,
    DateRangePickerModule,
    FormsModule,
    FullCalendarModule,
    CalendarModule,
    DatePicker,
    SlickCarouselModule,
    RouterModule,
    SelectComponent,
    CustomPaginationModule
  ],
  exports: [
    // modules
    CommonModule,
    NgScrollbarModule,
    MatTooltipModule,
    LightboxModule,
    CarouselModule,
    BsDatepickerModule,
    LightgalleryModule,
    MatSelectModule,
    MatSortModule,
    NgScrollbarModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgApexchartsModule,
    TooltipModule,
    ToastModule,
    NgxEditorModule,
    PopoverModule,
    DateRangePickerModule,
    FooterComponent,
    FormsModule,
    FullCalendarModule,
    DatePicker,
    CalendarModule,
    SlickCarouselModule,

    // component
    CommonCounterComponent,
    UserDashboardComponent,
    BookingSearchBarComponent,
    DefaultHeaderComponent,
    HeaderTopBarComponent,
    LocationPickerComponent,
    FlightSearchComponent,
    HotelSearchComponent,
    CityPickerComponent,
    CarSearchComponent,
    PaginatorComponent,
    StaticContentComponent,
    CustomPaginationModule
  ],
  providers: [
    provideNgxMask(),
    DatePipe,
    BsDatepickerConfig,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModule { }
